export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-ru-7319ac5c60f05d4d4b00ae9592fa096a.png";